import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ContactCoreServicesModule } from '@farm-portal/core/contact';
import { SidebarDirective } from '@farm-portal/core/layout/directives/sidebar.directive';
import { SidebarAnchorToggleDirective } from '@farm-portal/core/layout/directives/sidebaranchortoggle.directive';
import { SidebarLinkDirective } from '@farm-portal/core/layout/directives/sidebarlink.directive';
import { SidebarListDirective } from '@farm-portal/core/layout/directives/sidebarlist.directive';
import { LangSelectorComponent } from '@farm-portal/core/layout/navbar/lang-selector/lang-selector.component';
import { MessageUnreadNotificationComponent } from '@farm-portal/core/layout/navbar/message-unread-notification/message-unread-notification.component';
import { NavbarNotificationsComponent } from '@farm-portal/core/layout/navbar/navbar-notifications/navbar-notifications.component';
import { NavbarComponent } from '@farm-portal/core/layout/navbar/navbar-template/navbar.component';
import { UserNavItemComponent } from '@farm-portal/core/layout/navbar/navbar-template/user-nav-item/user-nav-item.component';
import { SidebarComponent } from '@farm-portal/core/layout/sidebar/sidebar.component';
import { MessageCoreServicesModule } from '@farm-portal/core/message/message-core-services.module';
import { FormInputsModule } from '@farm-portal/shared/modules/form-inputs/form-inputs.module';
import { LayoutModule } from '@farm-portal/shared/modules/layout/layout.module';
import { NgbDropdownModule, NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { PipesModule, SpinnerModule, TranslationModule } from 'farmcloud-core';
import { FullLayoutComponent } from './full-layout/full-layout.component';
import { LoadAslUserDataComponent } from './load-external-user-data/load-asl-user-data.component';
import { LoadUserDataComponent } from './load-user-data/load-user-data.component';
import { CartNavItemComponent } from './navbar/cart-nav-item/cart-nav-item.component';
import { FarmNavItemComponent } from './navbar/farm-nav-item/farm-nav-item.component';

@NgModule({
  declarations: [
    FullLayoutComponent,
    LoadUserDataComponent,
    FarmNavItemComponent,
    LoadAslUserDataComponent,
    SidebarListDirective,
    SidebarDirective,
    SidebarLinkDirective,
    SidebarAnchorToggleDirective,
    NavbarComponent,
    UserNavItemComponent,
    SidebarComponent,
    NavbarNotificationsComponent,
    MessageUnreadNotificationComponent,
    LangSelectorComponent,
    CartNavItemComponent
  ],
  imports: [
    CommonModule,
    TranslationModule,
    RouterModule,
    SpinnerModule,
    ContactCoreServicesModule,
    MessageCoreServicesModule,
    NgbDropdownModule,
    NgbNavModule,
    NgbModule,
    FormInputsModule,
    PipesModule,
    LayoutModule
  ],
  exports: [FullLayoutComponent, NavbarNotificationsComponent, LangSelectorComponent]
})
export class LayoutCoreModule {}
